import { NgModule } from "@angular/core";
import { DepositECheckPage } from "./deposit-e-check";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { ReactiveFormsModule } from "@angular/forms";
import { ComponentsModule } from "src/app/components/components.module";

@NgModule({
  declarations: [DepositECheckPage],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
  ],
})
export class DepositECheckPageModule {}
